import { Box, Skeleton, styled } from "@mui/material";

import PropTypes from "prop-types";

import React, { useState } from "react";

import { Thumbs, FreeMode } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/thumbs";

function ImageGallery(props) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  return (
    <>
      <Swiper
        modules={[Thumbs]}
        thumbs={{
          swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
        }}
      >
        {props.images.map((image) => (
          <SwiperSlide key={image}>
            <ImagePreview src={image} alt={image} />
          </SwiperSlide>
        ))}
      </Swiper>

      <Box
        component={Swiper}
        spaceBetween={15}
        modules={[Thumbs, FreeMode]}
        watchSlidesProgress
        onSwiper={setThumbsSwiper}
        slidesPerView={3}
        breakpoints={{ 900: { slidesPerView: 5 } }}
        sx={{ py: 2 }}
        className="seller-swiper-thumb-gallery"
      >
        {props.images.map((image) => (
          <SwiperSlide key={image}>
            <ImageGalleryThumb src={image} alt={image} />
          </SwiperSlide>
        ))}
      </Box>
    </>
  );
}

function ImageGallerySkeleton() {
  return (
    <>
      <Skeleton
        variant="rectangular"
        width="100%"
        sx={{ borderRadius: 1, height: "unset", aspectRatio: "16/9" }}
      />
      <Box display="flex" gap={2} py={2}>
        <Skeleton
          width="100%"
          variant="rectangular"
          sx={{ borderRadius: 1, height: "unset", aspectRatio: "1.3/1" }}
        />
        <Skeleton
          width="100%"
          variant="rectangular"
          sx={{ borderRadius: 1, height: "unset", aspectRatio: "1.3/1" }}
        />
        <Skeleton
          width="100%"
          variant="rectangular"
          sx={{ borderRadius: 1, height: "unset", aspectRatio: "1.3/1" }}
        />
        <Skeleton
          width="100%"
          variant="rectangular"
          sx={{
            borderRadius: 1,
            height: "unset",
            aspectRatio: "1.3/1",
            display: { xs: "none", md: "unset" },
          }}
        />
        <Skeleton
          width="100%"
          variant="rectangular"
          sx={{
            borderRadius: 1,
            height: "unset",
            aspectRatio: "1.3/1",
            display: { xs: "none", md: "unset" },
          }}
        />
      </Box>
    </>
  );
}

const ImagePreview = styled("img")({
  borderRadius: "7px",
  width: "100%",
  aspectRatio: "16/9",
  objectFit: "cover",
});

const ImageGalleryThumb = styled("img")({
  borderRadius: "7px",
  width: "100%",
  aspectRatio: "1.3/1",
  objectFit: "cover",
});

ImageGallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default React.memo(ImageGallery);
export { ImageGallerySkeleton };
